function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "vertical-slider-square--adjustment-adjust-controls-fader-vertical-settings-slider-square"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m1.036 3.107 0 22.786a2.071 2.071 0 0 0 2.071 2.071h22.786a2.071 2.071 0 0 0 2.071 -2.071v-22.786a2.071 2.071 0 0 0 -2.071 -2.071h-22.786a2.071 2.071 0 0 0 -2.071 2.071Z",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M9.321 22.786V12.429",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M9.321 12.429a3.107 3.107 0 1 0 0 -6.214 3.107 3.107 0 0 0 0 6.214Z",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M19.679 6.214v6.214",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_5",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M19.679 18.643v4.143",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_6",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M19.679 18.643a3.107 3.107 0 1 0 0 -6.214 3.107 3.107 0 0 0 0 6.214Z",
  strokeWidth: 1
}));

function SvgVerticalSliderSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "-0.5 -0.5 30 30",
    height: 30,
    width: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalSliderSquare);
export default __webpack_public_path__ + "static/media/vertical-slider-square.979fdf46.svg";
export { ForwardRef as ReactComponent };